
import { useRef, useEffect } from 'react';

const WWOpenDataCom = ({ type, openid, WWOpenData, }: { type: 'userName' | 'departmentName', openid: string | number, WWOpenData: any }) => {
    const ref = useRef(null);
    useEffect(() => {
        console.log('WWOpenDataCom', WWOpenData)
        if (WWOpenData) {
            WWOpenData.bind(ref.current);
        }
    }, [WWOpenData])
    return WWOpenData ? <ww-open-data ref={ref} type={type} openid={openid} /> : null
}
export default WWOpenDataCom;
